import mod from "-!./Pay.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Pay.js?vue&type=script&lang=js&"